var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function transApproach(tag, options) {
    var _a = __read(tag.replace('-', '_').split('_'), 2), lang = _a[0], region = _a[1];
    return [
        lang,
        region ? [
            options.connector === 'underline' ? '_' : '-',
            options.region === 'uppercase' ? region.toUpperCase() : (options.region === 'lowercase' ?
                region.toLowerCase() :
                region),
        ].join('') : '',
    ].join('');
}
export default transApproach;
